var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.167 1.583)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4884E8",
    d: "M4.6 5.405 7.758 0h4.585L9.185 5.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BA3FF",
    d: "m0 0 3.157 5.405h4.585L4.585 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BCC4CB",
    cx: 6.171,
    cy: 10.008,
    r: 5.825
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3E7ED",
    cx: 6.171,
    cy: 10.008,
    r: 4.604
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BCC4CB",
    cx: 6.171,
    cy: 10.008,
    r: 3.485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.626 11.875v-.704H6.014v-.037l.476-.48a11.8 11.8 0 0 0 .396-.41c.124-.134.233-.269.326-.405.094-.136.168-.275.222-.417.054-.141.081-.29.081-.445 0-.171-.028-.326-.085-.463a.965.965 0 0 0-.245-.35A1.106 1.106 0 0 0 6.8 7.94a1.549 1.549 0 0 0-.51-.079 1.738 1.738 0 0 0-1.074.353 3.867 3.867 0 0 0-.255.213l.455.538c.144-.13.282-.23.414-.3a.862.862 0 0 1 .41-.106c.136 0 .244.037.324.111.08.074.12.178.12.311 0 .121-.018.234-.056.339a1.396 1.396 0 0 1-.16.308c-.068.101-.15.205-.246.311-.096.107-.202.223-.32.35l-.93 1.003v.582h2.654z",
    fill: "#7C909A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSilver);
export default __webpack_public_path__ + "static/media/medal-silver.8bb1aafa.svg";
export { ForwardRef as ReactComponent };